import React from 'react';
import TextMessage from './text-message';
import ButtonIcon from './button-icon';
import { buttonClickHandler } from './button-click-handler';

export default function Buttons({ message = {}, onInvokeAction, disabled }) {
  const onClick = buttonClickHandler(onInvokeAction);
  const buttons = Array.isArray(message.buttons) ? message.buttons : [];

  return (
    <div className="w-full">
      {message.displayText && <TextMessage message={message.displayText} />}

      {/* Buttons sit inside the agent bubble (bg-surface), so they step up a
          level to stay distinguishable from their container. */}
      <div className="mt-3 flex flex-wrap items-center gap-2">
        {buttons.map((option, index) => (
          <button
            key={option.id || index}
            type="button"
            disabled={disabled}
            onClick={() => onClick(option.payload, option)}
            className="inline-flex items-center rounded-lg border border-hairline bg-elevated px-3.5 py-2 text-sm
              text-ink transition-colors hover:border-accent hover:text-accent
              disabled:cursor-not-allowed disabled:opacity-50"
          >
            <ButtonIcon icon={option.icon} alt={option.title} />
            {option.title}
          </button>
        ))}
      </div>
    </div>
  );
}
